<template>
    <div>
        <zlm-dynamic-page :config="config" />
    </div>
</template>

<script>
    export default {
    }
</script>

<style>
</style>
